
export class PoolEnums {
    static readonly PERMA = 1; // do we need this pool anymore?
    static readonly PEPUSI = 2;
    static readonly ICAP = 3;
    static readonly LARM = 4;
    static readonly PEPBF = 5;
    static readonly BCJPIA = 6;
    static readonly IPARKS = 7;
    static readonly OTARMA = 8;
    static readonly PIRMA = 9;
    static readonly VSWCF = 10;
    static readonly TWCARMF = 11;
    static readonly TCRMF = 12;
    static readonly CALTIP = 53;
    static readonly DEMO = 9999;
}
